import { ref } from 'vue'
import { getSupplierList as getSupplierListApi } from '@/api/project/integralSeckill/manageGoods'

export default function useSupplier() {
  const supplierList = ref([]) // 供应商列表
  // 获取供应商列表
  const getSupplierList = () => {
    const body = {
      is_enable: '1',
      page_size: 0,
      last_id: '0',
    }
    getSupplierListApi(body).then((res) => {
      if (res.code === 0) {
        supplierList.value = res.data.supplier_list.map((v) => {
          return {
            value: v.id,
            label: v.name,
          }
        })
      }
    })
  }
  // 新增供应商
  const supplierModal = ref(null)
  const addSupplier = () => {
    supplierModal.value.setModalForm()
  }
  return {
    supplierList,
    supplierModal,
    getSupplierList,
    addSupplier,
  }
}
